import { api_client, gqlQueryParams, handleGqlResponse } from "@shared/api";
import { LIST_PARAMETERS_QUERY } from "./query";
import { GQL_API_KEY, GQL_END_POINT } from "../client-env-file";

type ListParameterArgs = {
  paramService: string;
  paramNames: string[];
};

export const listParameters = async ({ paramService, paramNames }: ListParameterArgs) => {
  const listParametersQueryParams = gqlQueryParams(LIST_PARAMETERS_QUERY, { paramNames: paramNames, paramService: paramService });
  const listParametersResponse = await api_client.post<Record<string, Record<string, string>>>(listParametersQueryParams, GQL_END_POINT, GQL_API_KEY);
  return handleGqlResponse(listParametersResponse, 'listParameters');
};